import { whyUs } from "@/mocks/homeData";

export default function WhyUs() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="reveal">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-bold tracking-wide uppercase mb-4">
              ¿Por qué elegirnos?
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
              No somos técnicos improvisados. Somos{" "}
              <span className="text-primary-600">ingenieros</span> con 35 años de
              trayectoria.
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8">
              Cuando contratas a SERIN, no contratas un servicio cualquiera.
              Contratas experiencia real, garantía escrita y un equipo que cumple
              normas de seguridad y salud en el trabajo.
            </p>

            <a
              href="https://wa.link/b002hg"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Solicitar cotización
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* Right Grid */}
          <div className="grid sm:grid-cols-2 gap-4 md:gap-5">
            {whyUs.map((item, i) => (
              <div
                key={i}
                className="reveal bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/60 hover:shadow-md transition-all duration-300"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-primary-600 text-lg`} />
                </div>
                <h3 className="font-heading font-bold text-foreground-950 text-sm mb-1.5">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}